function transliterate(c) {
  return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
}

function getIndexWeight(i) {
  const weights = '8765432a098765432';
  const map = '0123456789a';
  return map.indexOf(weights[i]);
}

function calculateCheckDigit(vin) {
  let sum = 0;
  for (let i = 0; i < vin.length; i += 1) {
    sum += transliterate(vin[i]) * getIndexWeight(i);
  }
  const result = sum % 11;
  return result === 10 ? 'X' : `${result}`;
}

export const validateVin = (_vin) => {
  if (!_vin) {
    return null;
  }
  const vin = _vin.toUpperCase();

  if (vin.length < 17) {
    return { vinMinLength: 'has too few characters' };
  }

  if (
    vin.indexOf('I') !== -1 ||
    vin.indexOf('O') !== -1 ||
    vin.indexOf('Q') !== -1
  ) {
    return { invalidVin: 'has invalid characters' };
  }
  return vin[8] !== calculateCheckDigit(vin)
    ? { posInvalidVin: 'check digit failed' }
    : null;
};
